import type { LinkProps } from '@ps/web-shared-components';
import { Link } from '@ps/web-shared-components';
import classNames from 'clsx';
import React, { createElement } from 'react';

import styles from './StarsNavigation.scss';

export interface Props extends Partial<LinkProps> {
  active?: boolean;
  tagName?: string;
  values?: { [key: string]: string };
}

const StarsNavigationItem: React.FC<Props> = ({
  active,
  activeClassName,
  children,
  tagName,
  values,
  ...linkProps
}) => {
  const activeClass = classNames(styles.active, activeClassName);
  const className = classNames(styles.navItem, linkProps.className, active && activeClass);
  const { isActive, ...elementProps } = linkProps;

  return tagName || (!linkProps.href && !linkProps.alias) ? (
    createElement(tagName || 'span', { ...elementProps, className }, children)
  ) : (
    <Link
      {...linkProps}
      href={linkProps.href}
      values={values}
      className={className}
      activeClassName={typeof active !== 'boolean' ? activeClass : undefined}
    >
      {children}
    </Link>
  );
};

export default StarsNavigationItem;
